export const INTERNAL_ROW_ID = '__aritoInputRowId';
export const INTERNAL_ROW_INDEX = '__aritoInputRowIndex';

export const stripInternalFields = <T>(row: T): T => {
  if (!row || typeof row !== 'object') return row;

  const { [INTERNAL_ROW_ID]: _rowId, [INTERNAL_ROW_INDEX]: _rowIndex, ...rest } = row as Record<string, unknown>;
  return rest as T;
};
